import { enableProdMode, importProvidersFrom } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

import { appConfig } from './app/app.config';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    // browser-only modules and providers
    provideAnimationsAsync(),
    importProvidersFrom(
      ServiceWorkerModule.register('/assetz/ngsw-worker.js', {
        scope: '/',
        enabled: true
      })
    ),
    ...(appConfig.providers ?? [])
  ]
}).catch(err => console.error(err));
